import React, { useEffect, useState } from 'react';
import LineTittle from '../Component/LineTittle';
import * as images from "../constant/imges";
import { neuroCognitive, problemsFace, wiserSolution } from '../constant/homeData';
import { lineBar, bulitPoint } from '../constant/svgs';
import { Link } from 'react-router-dom';
import WiserSlider from "../Component/SlideFeature";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cookies from 'js-cookie';
import wiserVideo from '../assets/video/home_section_video.mp4';
import Modal from '../Component/Modal';
import { Switch } from 'antd';

const Home = () => {

    const [showCookieBanner, setShowCookieBanner] = useState(true);
    const [showCookieSettings, setShowCookieSettings] = useState(false);
    const [cookiePreferences, setCookiePreferences] = useState({
        necessary: true,
        analytics: false,
        marketing: false
    });

    useEffect(() => {
        const consent = Cookies.get('cookie_consent');
        if (consent === 'accepted') {
            loadGoogleAnalytics();
            setShowCookieBanner(false);
        } else if (consent === 'necessary') {
            setShowCookieBanner(false);
        } else {
            setShowCookieBanner(true);
        }
    }, []);

    const handleAcceptCookies = () => {
        setShowCookieBanner(false);
        Cookies.set('cookie_consent', 'accepted', { expires: 365 });
        loadGoogleAnalytics();
    };

    const handleNecessaryCookies = () => {
        setShowCookieBanner(false);
        Cookies.set('cookie_consent', 'necessary', { expires: 365 });
        loadGoogleAnalytics();
    };

    const handleCookieSettings = () => {
        setShowCookieSettings(true);
    };

    const handleSaveCookieSettings = () => {
        // Save the current state of cookie preferences
        Cookies.set('cookie_preferences', JSON.stringify(cookiePreferences), { expires: 365 });

        // If analytics cookies are accepted, load Google Analytics
        if (cookiePreferences.analytics) {
            loadGoogleAnalytics();
        }

        // If all cookies are accepted, set a flag to not show the modal again
        if (cookiePreferences.necessary && cookiePreferences.analytics && cookiePreferences.marketing && cookiePreferences.advertising) {
            Cookies.set('cookie_consent', 'accepted', { expires: 365 });
        }

        // Close the modal and hide the banner
        Cookies.set('cookie_consent', 'accepted', { expires: 365 });
        loadGoogleAnalytics();
        setShowCookieSettings(false);
        setShowCookieBanner(false);
    };

    const loadGoogleAnalytics = () => {
        const script1 = document.createElement('script');
        script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-C41J0E8EWH';
        script1.async = true;
        document.head.appendChild(script1);

        const script2 = document.createElement('script');
        script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-C41J0E8EWH');
        `;
        document.head.appendChild(script2);
    };
    useEffect(() => {
        AOS.init({});
    }, []);
    return (
        <>
            <div className='aboutUs' >
                <div className='col-lg-9 col-11 m-auto' id='about'>
                    <div className='row'>
                        <div className='col-md-6 align-self-stretch' data-aos="fade-right">
                            <LineTittle title={"About us"} color={'text-dark'} />
                            <h1 className='mt-3'> Revolutionizing <span className='text-yellow'>Education</span> </h1>
                            <p className='mt-3'>Discover WiserBee, the ultimate all-in-one EdTech platform transforming the educational experience. Designed for every stakeholder—learners, educators, administrators, parents, and institutions—our integrated platform delivers a seamless personalized experience. It combines powerful learning tools, student and school management systems, automated fee handling, and human resource management into a single, efficient solution. WiserBee streamlines operations, provides real-time insights, and empowers personalized learning and enhanced teaching, creating a more effective way to educate.
                                <br></br>
                                Join us in shaping the future of learning with WiserBee!</p>
                        </div>
                        <div className='col-md-6 align-self-stretch' data-aos="flip-left">
                            <img className='yLogo img-fluid' src={images.yLogo} alt='yLogo' style={{ maxWidth: '100%', height: 'auto' }} />
                        </div>
                    </div>
                </div>

                <div className='problemsFace'>
                    <div className='col-lg-9 col-11 m-auto'>
                        <div className='row pb-3'>
                            <div className='col-md-6 align-self-center'>
                                <LineTittle title={"Problems Faced Today"} color={'text-dark'} />
                                <h1 className='mt-3'>Behavioral Frustrations in  <span className='text-yellow'>Education</span> </h1>
                            </div>
                            <div className='col-md-6 align-self-center'>
                                <p>These issues manifest as behavioral frustrations, leading to dissatisfaction and low self-esteem. To foster a more productive society, these reflective areas need attention and resolution.</p>
                            </div>
                        </div>
                        <div className='row my-5'>
                            {problemsFace.map((item, index) => (
                                <div className='col-md-3 col-6 mb-4' key={index} data-aos="fade-right"
                                    data-aos-offset="150"
                                    data-aos-easing="ease-in-sine">
                                    <span className='prblemIcons '>{item.icon}</span>
                                    <h6 className='neurocogTittle h-25 mt-4 '>{item.titleFirst} <br /> {item.titleSecond}</h6>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className='wiserBeeSolution'>
                    <div className='col-lg-9 col-11 m-auto'>
                        <div className='row my-5'>
                            <div className='col-lg-6 align-self-center'>
                                <h1 className='mt-3'> WiserBee's <br></br> <span className='text-yellow'>Solution</span> </h1>
                                <p>NeuroScience-Based Screening for Learners and Teachers, Enhancing Neurocognitive Development in Humans.</p>
                            </div>
                            <div className='col-lg-6'>
                                <div className='row'>
                                    {wiserSolution.map((item, index) => (
                                        <div className='col-sm-6   d-flex align-items-stretch mt-3' key={index} data-aos="flip-right">
                                            <div className=' educationCard '>
                                                <span className='prblemIcons '>{item.icon}</span>
                                                <h6 className='neurocogTittle h-25 mt-4'>{item.title}</h6>
                                                <p className='neurocogdetails mt-3'>{item.details}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='neurocognitive'>
                    <div className='col-lg-9 col-11 m-auto'>
                        <div className='row'>
                            <div className='col-lg-6 align-self-center'>
                                <h1 className='mt-3'><span className='text-yellow'> Neurocognitive </span><br></br> Screening</h1>
                                <p className='mt-3'>NeuroScience-Based Screening for Learners and Teachers, Enhancing Neurocognitive Development in Humans.</p>
                            </div>
                            <div className='col-lg-6 '>
                                <div className='row'>
                                    {neuroCognitive.map((item, index) => (
                                        <div className='col-sm-6 mb-3' key={index} data-aos="zoom-in">
                                            {item.icon}
                                            <h6 className='neurocogTittle'>{item.title}</h6>
                                            <p className='neurocogdetails'>{item.details}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='bgWiser d-none d-sm-block'>
                        <img className='Bgwiser' src={images.Bgwiser} alt='Bgwiser' style={{ objectFit: 'contain', width: '100%', height: 'auto' }} />
                    </div>
                </div>
                <div className='featureSection' id="features">
                    <WiserSlider />
                </div>
                <div className='wiseradviserSec'>
                    <div className='col-lg-9 col-11 m-auto'>
                        <div className='row'>
                            <div className='col-md-6 d-flex align-items-stretch'>
                                <video autoPlay loop muted width="100%" height="auto">
                                    <source src={wiserVideo} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <div className='col-md-6'>
                                <LineTittle title={"A1 ChatBot"} color={'text-dark'} />
                                <h1 className='mt-3'>Wiser-Adviser</h1>
                                <p className='text-yellow'>Your all-in-one A1 companion for education excellence!</p>
                                <p>Wiser-Adviser provides tailored assistance to individual
                                    learners, offering guidance on study materials, clarifying
                                    concepts, and suggesting personalized learning strategies to
                                    maximize academic success.</p>
                                <div className='mt-5'>
                                    <Link className="reqforDemoBtn" to="/wiser-adviser">View Detail</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='virtualSecion'>
                    <div className='col-lg-9 col-11 m-auto'>
                        <div className='row'>
                            <div className='col-md-6' data-aos="flip-right">
                                <img className='w-100' src={images.virtual} alt='' />
                            </div>
                            <div className='col-md-6'>
                                <LineTittle title={"Wiser Connect"} color={'text-dark'} />
                                <h1 className='mt-3'>A1-Powered Virtual
                                    Meeting Software </h1>
                                <p className="d-flex justify-content-start"><span className='mx-2'>{bulitPoint}</span>Scheduling Meetings</p>
                                <p className="d-flex justify-content-start"><span className='mx-2'>{bulitPoint}</span>Live Lectures</p>
                                <p className="d-flex justify-content-start"><span className='mx-2'>{bulitPoint}</span>Live Sessions Recordings In Multiple Languages</p>
                                <p className="d-flex justify-content-start"><span className='mx-2'>{bulitPoint}</span>Live Audio Translation In Multiple Languages.</p>
                                <p className="d-flex justify-content-start"><span className='mx-2'>{bulitPoint}</span>Live Transcript Into Multiple Languages</p>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='col-lg-9 col-11 m-auto'>
                    <div className='row' id='partners'>
                        <div className='col-lg-6'>
                            <LineTittle title={"Partners"} color={'text-dark'} />
                            <h1 className='mt-3'>Companies Supporting Our Cause </h1>
                            <p>At WiserBee, we are committed to transforming education through technology, making learning more accessible, engaging, and innovative. With the support of global technology giants, we are revolutionizing the EdTech space by integrating advanced tools, AI-driven insights, and seamless digital experiences. Their collaboration empowers us to shape the future of learning and create meaningful impact in education.</p>
                        </div>
                        <div className='col-lg-6'>
                            <div className='row'>
                                <div className='col-6' data-aos="fade-left">
                                    <img className='brandLogos' src={images.pycapLogo} alt='pycap' />
                                </div>
                                <div className='col-6' data-aos="fade-right">
                                    <img className='brandLogos' src={images.amazon} alt='amazon' />
                                </div>
                                <div className='col-6' data-aos="fade-right">
                                    <img className='brandLogos' src={images.qstp} alt='qstp' />
                                </div>
                                <div className='col-6' data-aos="fade-left">
                                    <img className='brandLogos' src={images.microLogo} alt='micro' />
                                </div>
                                <div className='col-6' data-aos="fade-right">
                                    <img className='brandLogos' src={images.erdcLogo} alt='erdc' />
                                </div>
                                <div className='col-6' data-aos="fade-right">
                                    <img className='brandLogos' src={images.NVIDIA} alt='NVIDIA' />
                                </div>
                                <div className='col-6' data-aos="fade-right">
                                    <img className='brandLogos' src={images.google} alt='google' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row my-5 align-items-center' id='ourTeam'>
                        <div className='col-md-6' data-aos="fade-right">
                            <LineTittle title={"Founder & CEO"} color={'text-dark'} />
                            <h1 className='mt-3'>A Message from Our <span className='text-yellow'>Founder & CEO</span></h1>
                            <p className='mt-3'>At WiserBee, we believe technology should empower educators, not replace them, and help every student reach their full potential.</p>
                            <p>With more than 26 years of experience in global business, technology and transformation, I founded WiserBee to address a challenge I saw across education: fragmented systems that make it difficult for educators and leaders to focus on what matters most—students.</p>
                            <p>WiserBee brings AI, learning, student support and school management together on one intelligent platform, helping institutions become more connected, efficient and future-ready.</p>
                            <p>We are passionate about responsible AI, education innovation and entrepreneurship, and our mission is simple: to help educators teach better, leaders lead smarter, and students thrive.</p>
                            <p>I invite educators, institutions and partners to join us in building a wiser future for education.</p>
                            <div className='mt-4'>
                                <h5 className='mb-1'>Khawaja Zubair Ahmed</h5>
                                <p className='text-yellow mb-0'>Founder & CEO, WiserBee Technologies</p>
                            </div>
                        </div>
                        <div className='col-md-6 d-flex justify-content-center' data-aos="fade-left">
                            <img className='img-fluid rounded-3' src={images.zubair} alt='Khawaja Zubair Ahmed - Founder & CEO' style={{ maxWidth: '100%', height: 'auto' }} />
                        </div>
                    </div>
                </div>

                <div className=''>
                    <div className='col-lg-8 col-11 m-auto'>
                        <div className='reqDemo'>
                            <img className='reqDemoImg' src={images.reqDemo} alt='reqDemo' />
                            <div className='reqDemoDetail text-center' data-aos="zoom-in">
                                <span className='d-flex justify-content-center align-items-center gap-3'>
                                    {lineBar}
                                    <h1 className={`lineBarText mb-0`}>Make learning easy</h1>
                                    {lineBar}
                                </span>
                                <h1 className='mt-4'>Give WiserBee A Try Today. Request A <br></br> <span className='text-yellow'>Free Demo Now !</span></h1>
                                <div className='mt-5'>
                                    <Link className="reqforDemoBtn" to="/req-demo">Request For Demo</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showCookieBanner && !showCookieSettings && (
                <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    padding: '1rem',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                    alignItems: 'center',
                    width: '40%',
                    borderRadius: '10px'
                }}>
                    <h1 className='text-primary-color'>We value your privacy</h1>
                    <p style={{ margin: 0, padding: '2rem 0rem' }}>We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.</p>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <button
                            onClick={handleAcceptCookies}
                            style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: '#251963',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                borderRadius: '10px'
                            }}
                        >
                            Accept All
                        </button>
                        <button
                            onClick={handleNecessaryCookies}
                            style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: 'transparent',
                                color: '#251963',
                                border: '1px solid #251963',
                                cursor: 'pointer',
                                borderRadius: '10px'
                            }}
                        >
                            Necessary Cookies Only
                        </button>
                        <button
                            onClick={handleCookieSettings}
                            style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: 'transparent',
                                color: '#251963',
                                border: '1px solid #251963',
                                cursor: 'pointer',
                                borderRadius: '10px'
                            }}
                        >
                            Cookie Settings
                        </button>
                    </div>
                </div>
            )}

            <Modal show={showCookieSettings} onClose={() => setShowCookieSettings(false)}>
                <div className="">
                    <h3 className="mb-3">Cookie Settings</h3>
                    <div className="mb-4">
                        <div className="form-check mb-3 border border-dark rounded-3 p-2">
                            <label className="form-check-label d-flex align-items-center justify-content-between gap-3">
                                <div>
                                    <span className='fw-bold'>Necessary Cookies (Required)</span>
                                    <small className="text-muted d-block">These cookies are required for good functionality of our website and can't be switched off in our system.</small>
                                </div>
                                <Switch checked={cookiePreferences.necessary} disabled />
                            </label>
                        </div>
                        <div className="form-check mb-3 border border-dark rounded-3 p-2">
                            <label className="form-check-label d-flex align-items-center justify-content-between gap-3">
                                <div>
                                    <span className='fw-bold'>Performance</span>
                                    <small className="text-muted d-block"> We use these cookies to provide statistical information about our website - they are used for performance measurement and improvement.</small>
                                </div>
                                <Switch
                                    checked={cookiePreferences.analytics}
                                    onChange={(checked) => setCookiePreferences({
                                        ...cookiePreferences,
                                        analytics: checked
                                    })}
                                />
                            </label>
                        </div>
                        <div className="form-check mb-3 border border-dark rounded-3 p-2">
                            <label className="form-check-label d-flex align-items-center justify-content-between gap-3">
                                <div>
                                    <span className='fw-bold'>Functional</span>
                                    <small className="text-muted d-block">We use these cookies to enhance functionality and 
                                        <br></br> allow for personalisation, such as live chats, videos and the use of social media.</small>
                                </div>
                                <Switch
                                    checked={cookiePreferences.marketing}
                                    onChange={(checked) => setCookiePreferences({
                                        ...cookiePreferences,
                                        marketing: checked
                                    })}
                                />
                            </label>
                        </div>
                        <div className="form-check mb-3 border border-dark rounded-3 p-2">
                            <label className="form-check-label d-flex align-items-center justify-content-between gap-3">
                                <div>
                                    <span className='fw-bold'>Advertising</span>
                                    <small className="text-muted d-block"> These cookies are set through our site by our advertising partners.
                                         Data is collected for the purpose of advertising personalization and measuring 
                                        <br></br> the effectiveness of advertising campaigns. 
                                         Data may be shared with Google LLC, more information can be found
                                    </small>
                                </div>
                                <Switch
                                    checked={cookiePreferences.advertising}
                                    onChange={(checked) => setCookiePreferences({
                                        ...cookiePreferences,
                                        advertising: checked
                                    })}
                                />
                            </label>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <button
                            onClick={handleSaveCookieSettings}
                            style={{
                                padding: '0.5rem 1rem',
                                backgroundColor: 'transparent',
                                color: '#251963',
                                border: '1px solid #251963',
                                cursor: 'pointer',
                                borderRadius: '10px'
                            }}
                        >
                            Accept & Save Settings
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default Home;
